// SettingsConfiguration.js - Main entry point for Settings Configuration
// This component renders the tabbed interface for system settings
import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import UserRolesTab from './UserRolesTab';
import AvailablePagesTab from './AvailablePagesTab';
import AvailableFeaturesTab from './AvailableFeaturesTab';
import MailerSettingsTab from './MailerSettingsTab';

const SettingsConfiguration = ({ userRole = 'superadmin' }) => {
  const [activeTab, setActiveTab] = useState(0);

  const isSuperAdmin = userRole === 'superadmin';

  const tabs = [
    { label: 'User Roles', component: <UserRolesTab currentUserRole={userRole} /> },
    ...(isSuperAdmin ? [{ label: 'Available Pages', component: <AvailablePagesTab /> }] : []),
    ...(isSuperAdmin ? [{ label: 'Available Features', component: <AvailableFeaturesTab /> }] : []),
    ...(isSuperAdmin ? [{ label: 'Mailer Settings', component: <MailerSettingsTab /> }] : []),
  ];

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>Settings</Typography>

      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {tabs[activeTab]?.component}
      </Box>
    </Box>
  );
};

export default SettingsConfiguration;
